import React from 'react';
import { Box } from '@mui/material';
import Scroll from './components/Scroll';
import WhatsAppIcon from './components/WhatsAppIcon';
import HomePage from './pages/HomePage';

function App() {
  return (
    <>
      <WhatsAppIcon />
      <Scroll />
      <Box>
        <HomePage />
      </Box>
    </>
  );
}

export default App;
